/*
 * One-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * HundredSquareElement.tsx - A single square within the hundred square.
*/

import { StyleSheet, View, ViewStyle } from 'react-native';

interface HundredSquareElementProps {
  width: number,
  height: number,
  color: 'white' | 'yellow',
  bottom: boolean,
  right: boolean
}

const HundredSquareElement = ({width, height, color, bottom, right}: HundredSquareElementProps) => {

  const squareStyle: ViewStyle[] = [styles.square, {width:width, height:height, backgroundColor: color} ];
  if (bottom) {
    squareStyle.push(styles.bottom);
  }
  if (right) {
    squareStyle.push(styles.right);
  }


  return (
    <View style={squareStyle}></View>
  );
};

export default HundredSquareElement;

const styles = StyleSheet.create({
  square: {
    color: '#20232a',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    borderLeftWidth: 3,
    borderTopWidth: 3,
    borderColor: 'black',
    overflow: 'hidden',
  },

  yellow: {
    backgroundColor: 'yellow'
  },

  white: {
    backgroundColor: 'white'
  },

  bottom: {
    borderBottomWidth: 3
  },

  right: {
    borderRightWidth: 3
  }
});
